import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = (headers = {}) => ({
  headers: { Authorization: `Bearer ${getToken()}`, ...headers },
  withCredentials: true,
});

export const getPurchaseRealtimeToken = async (branchId, companyId) =>
  (await axios.get(
    `${API_URL}/notifications/purchase-events/token/${branchId}`,
    withAuth(companyId ? { 'X-Company-Id': String(companyId) } : {})
  )).data;

export const resolvePurchaseRealtimeWebsocketUrl = (path, token) => {
  const url = new URL(path, API_URL);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  if (token) url.searchParams.set('token', token);
  return url.toString();
};

export const getWebPushPublicKey = async () =>
  (await axios.get(`${API_URL}/notifications/web-push/public-key`, withAuth())).data;

export const listMyWebPushSubscriptions = async () =>
  (await axios.get(`${API_URL}/notifications/web-push/me/subscriptions`, withAuth())).data;

export const saveMyWebPushSubscription = async (subscription) =>
  (await axios.post(`${API_URL}/notifications/web-push/me/subscriptions`, { subscription }, withAuth())).data;

export const sendTestWebPushNotification = async () =>
  (await axios.post(`${API_URL}/notifications/web-push/me/test`, {}, withAuth())).data;

export const deleteMyWebPushSubscription = async (id) =>
  (await axios.delete(`${API_URL}/notifications/web-push/me/subscriptions/${id}`, withAuth())).data;
